module.exports = __webpack_public_path__ + "static/img/success.58562780.png";